import TecnicoTelefoneService from "@/services/TecnicoTelefoneService";

export const tecnicoTelefone = {
  namespaced: true,
  state: {
    tecnicoTelefone: {},
  },
  actions: {
    getTecnicoTelefone({ commit }, payload) {
      return TecnicoTelefoneService.GetTecnicoTelefone(payload).then(
        (tecnicoTelefone) => {
          return Promise.resolve(tecnicoTelefone);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postTecnicoTelefone({ commit }, payload) {
      return TecnicoTelefoneService.PostTecnicoTelefone(payload).then(
        (tecnicoTelefone) => {
          return Promise.resolve(tecnicoTelefone);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putTecnicoTelefone({ commit }, payload) {
      return TecnicoTelefoneService.PutTecnicoTelefone(payload).then(
        (tecnicoTelefone) => {
          return Promise.resolve(tecnicoTelefone);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteTecnicoTelefone({ commit }, payload) {
      return TecnicoTelefoneService.DeleteTecnicoTelefone(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getTecnicoTelefoneOData({ commit }, payload) {
      return TecnicoTelefoneService.GetTecnicoTelefoneOData(payload).then(
        (tecnicoTelefone) => {
          return Promise.resolve(tecnicoTelefone);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default tecnicoTelefone;
